import api from '@/api';
import { LayoutForm } from '@xpeng/xdragon-ass-components';
import { Button, Form, message } from 'antd';
import { useMemo, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from '@/hooks/useTranslation';
import { useRequest } from 'ahooks';
import type { ActionRefType } from 'xui-pro';
import { LayoutTable } from 'xui-pro';

interface WorkingHourDetailProps {
  isGlobal?: any;
}

const WorkingHourDetail = (props: WorkingHourDetailProps) => {
  const { isGlobal } = props;
  const [form] = Form.useForm();
  const $ = useTranslation();
  const { modelCode } = useParams<{ modelCode: string; vin: string }>();
  const tableRef = useRef<ActionRefType>(null);
  const [total, setTotal] = useState(0);

  const {
    runAsync: request,
    data: list,
    loading: submitLoading
  } = useRequest(
    async e => {
      const params = {
        current: 1,
        pageSize: 20,
        ...tableRef?.current?.getParams?.(),
        ...form.getFieldsValue()
      };
      if (e?.current) {
        params.current = e.current;
        params.pageSize = e.pageSize;
      }
      params.size = params.pageSize;
      params.currentPage = params.current;
      const res = await api.sip.bookmap.getWorkHourList({
        ...params,
        smallCategoryCode: params.workCategory ? params.workCategory[2] : '',
        modelCode
      });
      if (res.code === 200) {
        setTotal(res.data?.total || 0);
        return res.data?.records ?? [];
      } else {
        setTotal(0);
        message.error(res.msg);
        return [];
      }
    },
    { manual: false }
  );

  const { data: workList } = useRequest(
    async () => {
      const res = isGlobal
        ? await api.sip.bookmap.getAllOperatePlaceAndWiTypeEu()
        : await api.sip.bookmap.allOperatePlaceAndWiType();
      if (res.code !== 200) {
        message.error(res.msg);
        return [];
      }
      return res.data;
    },
    { manual: false }
  );

  const formItems = useMemo(() => {
    return [
      {
        type: 'cascader',
        name: 'workCategory',
        label: $('工时大类/小类'),
        options: workList,
        props: {
          fieldNames: { label: 'name', value: 'code' },
          expandTrigger: 'hover'
        }
      },
      {
        type: 'input',
        name: 'wiCode',
        label: $('工时编码')
      },
      {
        type: 'input',
        name: 'wiName',
        label: $('工时名称')
      }
    ];
  }, [$, workList]);

  const columns = useMemo(() => {
    return [
      {
        title: $('工时编码'),
        dataIndex: 'wiCode'
      },
      {
        title: $('工时名称'),
        dataIndex: 'wiName'
      },
      {
        title: $('故障部位'),
        dataIndex: 'faultPartName'
      },
      {
        title: $('工时大类'),
        dataIndex: 'largeCategoryName'
      },
      {
        title: $('工时小类'),
        dataIndex: 'smallCategoryName'
      },
      {
        title: $('工时数量'),
        dataIndex: 'wiQty'
      },
      {
        title: $('车系'),
        dataIndex: 'saleCarSeriesCode'
      },
      {
        title: $('配件号'),
        dataIndex: 'partNo'
      },
      {
        title: $('备注'),
        dataIndex: 'remark'
      }
    ];
  }, [$]);

  const onPageChange = (pagination: any) => {
    request(pagination);
  };

  return (
    <>
      <LayoutForm
        formItems={formItems}
        mode='form'
        form={form}
        span={7}
        style={{
          padding: '12px',
          paddingBottom: '0',
          background: '#ffffff',
          borderRadius: '6px',
          width: '100%',
          marginBottom: '12px'
        }}
      >
        <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            type='primary'
            htmlType='submit'
            onClick={() => request({})}
            loading={submitLoading}
          >
            {$('查询')}
          </Button>
        </div>
      </LayoutForm>
      <LayoutTable
        actionRef={tableRef}
        columns={columns}
        dataSource={list}
        loading={submitLoading}
        onChange={onPageChange}
        pagination={{
          total
        }}
        emptyPlaceholder='-'
      />

      {/* <CURD
        formItems={formItems}
        request={request}
        form={{
          hasReset: true,
          mode: 'form'
        }}
        columns={columns}
        table={{ emptyPlaceholder: '-' }}
      /> */}
    </>
  );
};

export default WorkingHourDetail;
